var _style, _polygon, _path, _path2, _polygon2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _polygon3, _polygon4, _path12, _polygon5, _polygon6, _polygon7, _polygon8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlag2Uk({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 64 42",
    style: {
      enableBackground: "new 0 0 64 42"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#00237A;}\n\t.st1{fill:#FFFFFF;}\n\t.st2{fill:#CF142B;}\n")), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "64,36 64,6 38,21 "
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M61,0.8C60.2,0.3,59.2,0,58.1,0H5.8c-1,0-2,0.3-2.9,0.8L32,17.5L61,0.8z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M2.9,41.2C3.8,41.7,4.8,42,5.8,42h52.4c1,0,2-0.3,2.9-0.7L32,24.5L2.9,41.2z"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "0,6 0,36 26,21 "
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M27,20.4L0.1,4.9C0,5.1,0,5.4,0,5.7V6l26,15L27,20.4z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M37,21.6l26.9,15.6c0-0.3,0.1-0.5,0.1-0.8V36L38,21L37,21.6z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M63.3,39.1L35,22.7l-3,1.7l29.1,16.8C62,40.7,62.8,40,63.3,39.1z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M0.7,2.9L29,19.3l3-1.7L2.9,0.8C2,1.3,1.3,2,0.7,2.9z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M0.7,2.9c-0.3,0.6-0.5,1.3-0.6,2L27,20.4l2-1.2L0.7,2.9z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M35,22.7L63.3,39c0.3-0.6,0.5-1.2,0.6-1.9L37,21.6L35,22.7z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M31,23.9L2,40.6c0.3,0.2,0.6,0.4,0.9,0.6L32,24.5L31,23.9z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M0.7,39.1L29,22.7L26,21L0,36v0.3C0,37.3,0.3,38.2,0.7,39.1z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M33,18.1L62,1.4c-0.3-0.2-0.6-0.4-0.9-0.6L32,17.5L33,18.1z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M63.3,3L35,19.3l3,1.7L64,6V5.7C64,4.7,63.7,3.8,63.3,3z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M0.7,39.1C1,39.7,1.5,40.2,2,40.7L31,24l-2-1.2L0.7,39.1z"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "32,21 31,22.7 30,22.2 29,22.7 31,23.9 33,22.7 "
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "31,22.7 32,21 30,22.2 "
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M63.3,3C63,2.4,62.5,1.9,62,1.4L33,18.1l2,1.2L63.3,3z"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "32,21 33,19.3 34,19.8 35,19.3 33,18.1 31,19.3 "
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "32,21 34,19.8 33,19.3 "
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "64,16 37,16 37,0 27,0 27,16 0,16 0,26 27,26 27,42 37,42 37,26 64,26 "
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "64,18 35,18 35,0 29,0 29,18 0,18 0,24 29,24 29,42 35,42 35,24 64,24 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlag2Uk);
export default __webpack_public_path__ + "static/media/flag_2_UK.f06f8371d6c7f63c75403732415b3acd.svg";
export { ForwardRef as ReactComponent };